import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { chatWebSocket, WSMessage } from '../services/chatWebSocket';

/**
 * Bridges the existing chat WebSocket to TanStack Query's cache.
 *
 * When the backend broadcasts `{type:"invalidate", entity:"factures"}` after
 * any user changes data, this invalidates every query keyed by that entity
 * (e.g. ["factures"] or ["factures", filters]). Mounted queries refetch in the
 * background so the current user sees the change in ~1s; unmounted queries are
 * just marked stale and refetch next time their page opens — costing no network
 * to users browsing other modules.
 *
 * Mount once, high in the tree, inside QueryClientProvider.
 */
const RealtimeQuerySync: React.FC = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubscribe = chatWebSocket.onMessage((message: WSMessage) => {
      if (message.type === 'invalidate' && message.entity) {
        queryClient.invalidateQueries({ queryKey: [message.entity] });
      }
    });
    return unsubscribe;
  }, [queryClient]);

  return null;
};

export default RealtimeQuerySync;
